import { MAJOR_TURN_OFF_OPTIONS } from '../MAJOR_TURN_OFF_OPTIONS';
import { MajorTurnOffOptionIdType } from '../types';

const DEFAULT: MajorTurnOffOptionIdType = 'arrogance';

export const getMajorTurnOffIdByTitle = (
  title: string | null | undefined,
  withDefault = false,
): MajorTurnOffOptionIdType | null => {
  const id = MAJOR_TURN_OFF_OPTIONS.find(
    (option) => option.title === title,
  )?.id;

  if (id) {
    return id;
  }

  if (withDefault) {
    return DEFAULT;
  }

  return null;
};
